
import { PaymentType } from '@/types/payment';
import { BiweeklyReportData } from './types';

export const useBiweeklyReport = (payments: PaymentType[]) => {
  const generateBiweeklyReport = (): BiweeklyReportData => {
    const today = new Date();
    const day = today.getDate();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    
    let reportStartDate: Date, reportEndDate: Date;
    
    if (day >= 16) {
      // For reports generated on or after the 16th of the month
      reportStartDate = new Date(currentYear, currentMonth, 16);
      reportEndDate = new Date();
    } else {
      // For reports generated on the 1st through 15th of the month
      reportStartDate = new Date(currentYear, currentMonth, 1);
      reportEndDate = new Date(currentYear, currentMonth, 15);
    }
    
    const reportPayments = payments.filter(payment => {
      const paymentDate = new Date(payment.date);
      return paymentDate >= reportStartDate && paymentDate <= reportEndDate;
    });
    
    return {
      payments: reportPayments,
      startDate: reportStartDate,
      endDate: reportEndDate
    };
  };

  return { generateBiweeklyReport };
};
